<template>
	<div>
		<breadcrumb :routerList="[{to:'/processLayout',title:'流程配置'},{title:'新建流程'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowCon">
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom:0.2rem">
									<h1>流程基础信息</h1>
								</div>
								<div class="h-pieceCon2">
									<el-form :model="formLabelAlign" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                                        <el-form-item label="流程名称" class="h-elformWrap-1" prop="formCon1">
                                            <el-input v-model="formLabelAlign.formCon1" placeholder="请填写"></el-input>
                                        </el-form-item>
                                        <el-form-item label="流程简介" class="h-elformWrap-1" prop="formCon2" style="margin-bottom:0">
                                            <el-input v-model="formLabelAlign.formCon2" maxlength="70" placeholder="请填写"></el-input>
                                            <el-input style="margin: 20px 0;" maxlength="70" v-model="formLabelAlign.formCon2" placeholder="请填写"></el-input>
                                        </el-form-item>
                                    </el-form>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom:0.2rem">
									<h1>流程配置</h1>
								</div>
								<div class="h-pieceCon2">
									<div id="mountNode"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
      return{
            formLabelAlign:{
                formCon1:'',
                formCon2:'',
            },
        }
    },
    methods:{
        
    },
    mounted(){
        this.dddd()
    }
}
</script>

<style scoped>

</style>
